__turbopack_context__.v({
  "blogModuleCard": "blog-module-card-module-scss-module__IaWhJG__blogModuleCard",
  "content": "blog-module-card-module-scss-module__IaWhJG__content",
  "description": "blog-module-card-module-scss-module__IaWhJG__description",
  "image": "blog-module-card-module-scss-module__IaWhJG__image",
  "imageContainer": "blog-module-card-module-scss-module__IaWhJG__imageContainer",
  "orange": "blog-module-card-module-scss-module__IaWhJG__orange",
  "purple": "blog-module-card-module-scss-module__IaWhJG__purple",
  "purple-light": "blog-module-card-module-scss-module__IaWhJG__purple-light",
  "tag": "blog-module-card-module-scss-module__IaWhJG__tag",
  "teal": "blog-module-card-module-scss-module__IaWhJG__teal",
});
